import React from 'react'

const getSrcSet = (filename) => {
    const medium = require(`./images/${filename}@2x.png`).default;
    const large = require(`./images/${filename}@3x.png`).default;
    return `${medium} 2x, ${large} 3x`
}

const IllustrationStyle = {
    'fontFamily': 'Lato',
    'fontSize': '16px',
    'fontWeight': 'normal',
    'fontStretch': 'normal',
    'fontStyle': 'normal',
    'lineHeight': '1.69',
    'letterSpacing': 'normal',
    'textAlign': 'center',
    'color': '#151a43',
    'marginTop': '36px'
}



const GetStartedIllustration = () => <img 
    src={require('./images/get-started-new.png').default}
    srcSet={getSrcSet('get-started-new')}
/> 

const SetupIllustration = () => <img 
    src={require('./images/setup-shared-mailbox-illustration.png').default} 
    srcSet={getSrcSet('setup-shared-mailbox-illustration')}
/>

const VerifySetupIllustration = () => <img 
    src={require('./images/verify-setup-illustration.png').default} 
    srcSet={getSrcSet('verify-setup-illustration')}
/>


const SuccessIllustration = () => 
    <img src={require('./images/almost-completed-illustration.png').default} 
    srcSet={getSrcSet('almost-completed-illustration')}
/>

const setupIllustrations = [{ 
    caption: 'Hiver helps you efficiently manage shared mailboxes like support@ or info@.',
    Illustration: GetStartedIllustration,
    captionWidth: '362px',
    IllustrationStyle: IllustrationStyle,
}, {
    caption: 'Set up your first shared mailbox. Add your team to Hiver. Experience a new way to collaborate.',
    Illustration: SetupIllustration,
    captionWidth: '337px',
    IllustrationStyle: IllustrationStyle
}, {
    caption: 'Connect your Gmail account OR verify your Google Groups setup and start receiving emails in your Hiver shared mailbox.',
    Illustration: VerifySetupIllustration,
    captionWidth: '337px',
    IllustrationStyle: IllustrationStyle
}, {
    caption: 'Just one more step to go. Install the Hiver extension and watch it work its magic inside your Gmail.',
    Illustration: SuccessIllustration,
    captionWidth: '369px',
    IllustrationStyle: IllustrationStyle
}];

const inviteIllustration = {
    caption: 'Use your Gmail to efficiently access, delegate and track Shared Inbox emails',
    Illustration: GetStartedIllustration,
    captionWidth: '345px'
}

export { 
    setupIllustrations,
    inviteIllustration
}